import React from 'react';
import { TypedMemo } from '../../../common/types';
import { PlugAvatar } from './PlugAvatar';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Outreach area; each part uses its own slice of it */
import styles from './Plug.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PlugWorkingProps {
  title: string;
  sub: string;
}

/**
 * Plug reads, finds or writes (design outreach p5): the busy avatar, the line, and three skeleton
 * lines. No spinner and no endless animation; the realtime event ends the state.
 */
const PlugWorkingComponent: React.FC<PlugWorkingProps> = ({ title, sub }) => (
  <div className={styles.work} data-testid="plug-working" role="status">
    <div className={styles.workHead}>
      <PlugAvatar size={40} state="busy" />
      <div>
        <b>{title}</b>
        <small>{sub}</small>
      </div>
    </div>
    <div className="d-flex flex-column gap-2">
      <div className={`${styles.shim} w-75`} />
      <div className={`${styles.shim} w-50`} />
      <div className={`${styles.shim} w-75`} />
    </div>
  </div>
);

export const PlugWorking = TypedMemo(PlugWorkingComponent);
